
import "./components";
//import './sprites';
import './images';
import './animations';


require('./favicons/favicon.ico');

/*
import * as lottie from '../core/components/lottieAnimation';

function init() {
    lottie.applyToElements();
}*/

// init();



// WEBPACK FOOTER //
// ./project/client/src/site__mhf/index.js